import { render, staticRenderFns } from "./inputFiltro.vue?vue&type=template&id=6af20749&"
import script from "./inputFiltro.vue?vue&type=script&lang=js&"
export * from "./inputFiltro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports